import styled from 'styled-components'

const AnswerGroupTitleUi = styled.div`
  display: flex;
  justify-content: space-around;
`

export default AnswerGroupTitleUi
